import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchJGGamesData, fetchJgPolasData } from '../../store/actions/jgGameAction';
import Loading from '../Loading';

const JokerGamingCard = (data) => {
  const dispatch = useDispatch();
  const { jgNames, jgImages, jgPolas, nameAndImagesIsLoading } = useSelector((state) => state.jgGameReducer);

  useEffect(() => {
    dispatch(fetchJgPolasData());
    dispatch(fetchJGGamesData());
  }, [dispatch]);

  if (data.isLoading || nameAndImagesIsLoading) return (
    <>
      <Loading />
    </>
  )

  return (
    <>
      <h2>Joker Gaming</h2>
      <section className="container px-3 sm:px-12 mx-auto" id="jg">
        <div className='grid grid-cols-2 lg:grid-cols-6 gap-4 justify-items-center'>
          {
            jgNames.map((jgName, i) => {
              return (
                <div key={i} className="w-full grid justify-items-center bg-item p-3">
                  <div className="relative flex-shrink-0">
                    <img width={"150px"} src={jgImages[i]} alt={jgName} />
                  </div>
                  <div className="grid box-content text-center content-center capitalize mb-3">
                    <span className="game-name h-12 grid content-center">{jgName}</span>
                    <div className="jam px-5 py-3 mb-3">
                      <span>Jam Gacor: </span>
                      <span className="jamGacor">
                        {data.jamGacors[i] ? data.jamGacors[i].value4 : ''}
                      </span>
                    </div>
                    <span>Pola: </span>
                    <span className="v">{jgPolas[i] ? `${jgPolas[i].value1} - ${jgPolas[i].value2} - ${jgPolas[i].value3}` : ''}</span>
                  </div>
                  <div className='single-bar relative items-center'>
                    <div className='absolute font-bold rtpValue' style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <span>{data.rtps[i] ? data.rtps[i].value4 : ''}%</span>
                    </div>
                    <div className="single-bar__fill bar animated-gradient" style={{ width: `${data.rtps[i] ? data.rtps[i].value4 : ''}%` }}></div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </section >
    </>
  );
};

export default JokerGamingCard;